import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "./initialState";
import api from "../api";

export const GetAllStaffMenuDropdown = createAsyncThunk(
  "staff_menu/GetAllStaffMenuDropdown",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(`${api}master/staff_menu`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllStaffMenu = createAsyncThunk(
  "staff_menu/GetAllStaffMenu",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(`${api}master/staff_menu/all?${data.url}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleStaffMenu = createAsyncThunk(
  "staff_menu/GetSingleStaffMenu",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/staff_menu/get_by_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const CreateStaffMenu = createAsyncThunk(
  "staff_menu/CreateStaffMenu",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(
        `${api}master/staff_menu`,
        {
          nama: data.nama,
          link_menu: data.link_menu,
          keterangan: data.keterangan,
          class_icon: data.class_icon,
          nama_menu_home: data.nama_menu_home,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const EditStaffMenu = createAsyncThunk(
  "staff_menu/EditStaffMenu",
  async (data, thunkAPI) => {
    try {
      const response = await axios.put(
        `${api}master/staff_menu/${data.id}`,
        {
          nama: data.nama,
          link_menu: data.link_menu,
          keterangan: data.keterangan,
          class_icon: data.class_icon,
          nama_menu_home: data.nama_menu_home,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const DeleteStaffMenu = createAsyncThunk(
  "staff_menu/DeleteStaffMenu",
  async (data, thunkAPI) => {
    let listData;
    try {
      const responseDelete = await axios.delete(
        `${api}master/staff_menu/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );

      if (responseDelete.data.success) {
        listData = await axios.get(`${api}master/staff_menu/all?${data.url}`, {
          headers: {
            Authorization: data.token,
          },
        });

        return {
          delete: responseDelete.data,
          meta: listData.data.meta,
          items: listData.data.items,
        };
      }
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const staffMenuSlice = createSlice({
  name: "staff_menu",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all menu
    builder.addCase(GetAllStaffMenuDropdown.pending, loadingHandler);
    builder.addCase(GetAllStaffMenuDropdown.fulfilled, fulfilledHandler);
    builder.addCase(GetAllStaffMenuDropdown.rejected, rejectedHandler);
    // get all menu
    builder.addCase(GetAllStaffMenu.pending, loadingHandler);
    builder.addCase(GetAllStaffMenu.fulfilled, fulfilledHandler);
    builder.addCase(GetAllStaffMenu.rejected, rejectedHandler);
    // get Single menu
    builder.addCase(GetSingleStaffMenu.pending, loadingHandler);
    builder.addCase(GetSingleStaffMenu.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleStaffMenu.rejected, rejectedHandler);
    // create menu
    builder.addCase(CreateStaffMenu.pending, loadingHandler);
    builder.addCase(CreateStaffMenu.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isCreate: true });
    });
    builder.addCase(CreateStaffMenu.rejected, rejectedHandler);
    // edit menu
    builder.addCase(EditStaffMenu.pending, loadingHandler);
    builder.addCase(EditStaffMenu.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isEdit: true });
    });
    builder.addCase(EditStaffMenu.rejected, rejectedHandler);
    // delete menu
    builder.addCase(DeleteStaffMenu.pending, loadingHandler);
    builder.addCase(DeleteStaffMenu.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isError: true });
    });
    builder.addCase(DeleteStaffMenu.rejected, rejectedHandler);
  },
});

export const { reset } = staffMenuSlice.actions;
export default staffMenuSlice.reducer;
